import { engineComponent, Utils } from "neo-common";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents, FrameTimer } from "../Utils/FrameTimer";
import { Tweens } from "../Components/Effects/Tweens";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { LayoutContainerElement } from "./LayoutContainerElement";
import { PlayList } from "../Components/Sounds/PlayList";
import { GsapEffects } from "../Components/Effects/GsapEffects";

@engineComponent(ComponentTypes.DisplayObject)
export class PaytableBoxElement extends LayoutContainerElement {
    static CaseEmpty: string = "EMPTY";
    static CaseDefault: string = "DEFAULT";
    static CaseMystery: string = "MYSTERY";
    static CaseShowLong: string = "SHOW_LONG";
    static CaseHideLong: string = "HIDE_LONG";
    public customTimer: FrameTimerEventEmitter; //todo Rename timer.
    public duration: number;
    public paytableBoxDrawId: number;
    public paytableBoxDrawRoundsCount: number;
    public paytableBoxSelectedId: number;
    private _paytableBoxDrawTimer: FrameTimerEventEmitter;
    private _paytableBoxSelectTimer: FrameTimerEventEmitter;
    private _idleCnt = 0;
    private _draw: number;

    private _drawStartedTime: number;
    private _drawCurrentTime: number;
    private _lastDelayToNextStep: number;

    private _drawInProgress: boolean;

    constructor() {
        super();

        this._paytableBoxDrawTimer = CreateFrameTimer("paytableBoxDrawTimer");
        this._paytableBoxDrawTimer.on(FrameTimerEvents.Complete, this.draw.bind(this));
        this._paytableBoxSelectTimer = CreateFrameTimer("paytableBoxSelectTimer");
        this.customTimer = CreateFrameTimer("customTimer");

        this._drawInProgress = false;
    }

    private _paytableBox: SwitchElement;

    get paytableBox(): SwitchElement {
        return this._paytableBox;
    }

    set paytableBox(value: SwitchElement) {
        this._paytableBox = value;
    }

    get drawInProgress(): boolean {
        return this._drawInProgress;
    }

    createByNode(node: Element): void {
        super.createByNode(node);
    }

    /**
     * @param symbolsOn
     * @param symbolsNoWinOn
     * @param symbolsGlowOff todo Rename to symbolsGlowOn and invert value?
     * @param multipliersGlowOff todo Rename to multipliersGlowOn and invert value?
     */
    public reset({ symbolsOn = true, symbolsNoWinOn = false, symbolsGlowOff = false, multipliersGlowOff = false }) {
        this._paytableBoxDrawTimer.stop();
        this._paytableBoxSelectTimer.stop();
        this._drawInProgress = false;

        if (!Utils.isNullOrUndefined(this._paytableBox)) {
            this._paytableBox.goToCase(PaytableBoxElement.CaseDefault);
            let symbolsNoWin = this._paytableBox.getChildElementByName("SymbolsNoWin") as ContainerElement;
            let symbols = this._paytableBox.getChildElementByName("Symbols") as ContainerElement;
            let symbolsGlow = this._paytableBox.getChildElementByName("SymbolsGlow") as ContainerElement;
            let multipliersGlow = this._paytableBox.getChildElementByName("MultipliersGlow") as ContainerElement;

            if (!Utils.isNullOrUndefined(symbols)) {
                for (let i = 0; i < symbols.children.length; i++) {
                    let symbol = symbols.children[i] as ContainerElement;
                    if (!Utils.isNullOrUndefined(symbol)) {
                        Tweens.removeTweens(symbol, "all");

                        if (symbolsOn) {
                            symbol.alpha = 1;
                        } else {
                            symbol.alpha = 0;
                        }
                    }
                }
            }

            if (!Utils.isNullOrUndefined(symbolsNoWin)) {
                for (let i = 0; i < symbolsNoWin.children.length; i++) {
                    let nowin = symbolsNoWin.children[i] as ContainerElement;
                    if (!Utils.isNullOrUndefined(nowin)) {
                        Tweens.removeTweens(nowin, "all");

                        if (symbolsNoWinOn) {
                            nowin.alpha = 1;
                        } else {
                            nowin.alpha = 0;
                        }
                    }
                }
            }

            if (!Utils.isNullOrUndefined(symbolsGlow)) {
                for (let i = 0; i < symbolsGlow.children.length; i++) {
                    let glows = symbolsGlow.children[i] as ContainerElement;
                    if (!Utils.isNullOrUndefined(glows)) {
                        Tweens.removeTweens(glows, "all");

                        if (symbolsGlowOff) {
                            glows.alpha = 0;
                        } else {
                            glows.alpha = 1;
                        }
                    }
                }
            }

            if (!Utils.isNullOrUndefined(multipliersGlow)) {
                for (let i = 0; i < multipliersGlow.children.length; i++) {
                    let multiplierGlow = multipliersGlow.children[i] as ImageElement;
                    if (!Utils.isNullOrUndefined(multiplierGlow)) {
                        Tweens.removeTweens(multiplierGlow, "all");

                        if (multipliersGlowOff) {
                            multiplierGlow.alpha = 0;
                        } else {
                            multiplierGlow.alpha = 0.9;
                        }
                    }
                }
            }
        }

        this.paytableBoxSelectedId = -1;
        this.paytableBoxDrawId = 0;
        this.paytableBoxDrawRoundsCount = 0;
    }

    /**
     *
     */
    public draw() {
        this._paytableBoxDrawTimer.stop();
        this._drawCurrentTime = Date.now();
        this._drawInProgress = true;
        let delayToNextStep: number;

        if (!Utils.isNullOrUndefined(this._paytableBox)) {
            let glow_group: ContainerElement;
            let nowin_group: ContainerElement;
            let symbols_group: any;
            let multiplierGlow_group: any;

            let symbolsNoWin = this._paytableBox.getChildElementByName("SymbolsNoWin") as ContainerElement;
            if (!Utils.isNullOrUndefined(symbolsNoWin)) {
                nowin_group = symbolsNoWin.children[this.paytableBoxDrawId] as ContainerElement;
            }

            let symbolsGlow = this._paytableBox.getChildElementByName("SymbolsGlow") as ContainerElement;
            if (!Utils.isNullOrUndefined(symbolsGlow)) {
                glow_group = symbolsGlow.children[this.paytableBoxDrawId] as ContainerElement;
            }

            let symbols = this._paytableBox.getChildElementByName("Symbols") as ContainerElement;
            if (!Utils.isNullOrUndefined(symbols)) {
                symbols_group = symbols.children[this.paytableBoxDrawId] as ImageElement;
            }

            let multipliersGlow = this._paytableBox.getChildElementByName("MultipliersGlow") as ContainerElement;
            if (!Utils.isNullOrUndefined(multipliersGlow)) {
                multiplierGlow_group = multipliersGlow.children[this.paytableBoxDrawId] as ImageElement;
            }

            let dt = (this._drawCurrentTime - this._drawStartedTime) / 1000;
            let ratio = dt / (this.duration * GsapEffects.TickTime);

            if (ratio < 0.25) {
                delayToNextStep = this.paytableBoxDrawRoundsCount / 3;
                this._lastDelayToNextStep = delayToNextStep;
            } else if (ratio < 0.66) {
                delayToNextStep = this._lastDelayToNextStep;
            } else {
                delayToNextStep = this.paytableBoxDrawRoundsCount / 4;
            }

            if (this.paytableBoxDrawId == this.paytableBoxSelectedId) {
                this._drawInProgress = false;
                PlayList.play("SND_SymbolWin");

                if (!Utils.isNullOrUndefined(symbols_group)) {
                    Tweens.removeTweens(symbols_group, "all");
                    Tweens.customTween(symbols_group, {
                        tween: "alpha",
                        tweenValues: [1, 0.9, 0],
                        tweenDuration: [30],
                        tweenLoop: true,
                    });
                }

                if (!Utils.isNullOrUndefined(glow_group)) {
                    Tweens.removeTweens(glow_group, "all");
                    Tweens.customTween(glow_group, {
                        tween: "alpha",
                        tweenValues: [1, 0.9, 0],
                        tweenDuration: [30],
                        tweenLoop: true,
                    });
                }

                if (!Utils.isNullOrUndefined(multiplierGlow_group)) {
                    Tweens.removeTweens(multiplierGlow_group, "all");
                    Tweens.customTween(multiplierGlow_group, {
                        tween: "alpha",
                        tweenValues: [1, 0.9, 0],
                        tweenDuration: [30],
                        tweenLoop: true,
                    });
                }

                this.customTimer.start(30);

                this.paytableBoxDrawRoundsCount = 0;
                return;
            }

            if (!Utils.isNullOrUndefined(symbols_group)) {
                Tweens.removeTweens(symbols_group, "all");
                Tweens.customTween(symbols_group, {
                    tween: "alpha",
                    tweenValues: [1, 0.9, 0],
                    tweenDuration: [20],
                });
            }

            if (!Utils.isNullOrUndefined(glow_group)) {
                Tweens.removeTweens(glow_group, "all");
                Tweens.customTween(glow_group, {
                    tween: "alpha",
                    tweenValues: [1, 0.9, 0],
                    tweenDuration: [20],
                });
            }

            if (!Utils.isNullOrUndefined(multiplierGlow_group)) {
                Tweens.removeTweens(multiplierGlow_group, "all");
                Tweens.customTween(multiplierGlow_group, {
                    tween: "alpha",
                    tweenValues: [1, 0.9, 0],
                    tweenDuration: [20],
                });
            }

            PlayList.play("SND_PaytableSymbolPick");

            this.paytableBoxDrawId++;
            if (this.paytableBoxDrawId >= symbols.children.length) {
                this.paytableBoxDrawId = 0;
            }

            this.paytableBoxDrawRoundsCount++;
            this._paytableBoxDrawTimer.start(delayToNextStep);
        }
    }

    /**
     * todo Remove.
     */
    public tweenItems(): void {
        Tweens.removeTweens(this, "_draw");
        Tweens.customTween(this, {
            tween: "_draw",
            tweenValues: [0, 1],
            tweenDuration: [this.duration],
            tweenEase: ["power2Out"],
            //callbacksInTime: callbacksInTime
            callbackType: "onUpdate",
            callbackFunction: () => {
                this.draw();
            },
        });
    }

    /**
     * Highlight selected symbol by ID.
     * @param selectedId
     * @param loop
     */
    public chooseSymbol(selectedId: number, loop = true) {
        this._paytableBoxDrawTimer.stop();

        if (!Utils.isNullOrUndefined(this._paytableBox)) {
            let symbols = this._paytableBox.getChildElementByName("Symbols") as ContainerElement;
            if (!Utils.isNullOrUndefined(symbols)) {
                let symbol = symbols.children[selectedId] as ContainerElement;
                if (!Utils.isNullOrUndefined(symbol)) {
                    if (loop) {
                        Tweens.removeTweens(symbol, "all");
                        Tweens.customTween(symbol, {
                            tween: "alpha",
                            tweenValues: [0, 1, 1, 0, 0],
                            tweenDuration: [2, 13, 2, 13],
                            tweenLoop: loop,
                        });
                    } else {
                        symbol.alpha = 1;
                    }
                }
            }

            let symbolsGlow = this._paytableBox.getChildElementByName("SymbolsGlow") as ContainerElement;
            if (!Utils.isNullOrUndefined(symbolsGlow)) {
                let glow = symbolsGlow.children[selectedId] as ContainerElement;
                if (!Utils.isNullOrUndefined(glow)) {
                    if (loop) {
                        Tweens.removeTweens(glow, "all");
                        Tweens.customTween(glow, {
                            tween: "alpha",
                            tweenValues: [0, 1, 1, 0, 0],
                            tweenDuration: [2, 13, 2, 13],
                            tweenLoop: loop,
                        });
                    } else {
                        glow.alpha = 1;
                    }
                }
            }
        }
    }

    /**
     * Hide all symbols except selected symbol by ID.
     * @param selectedId
     */
    public showOneSymbol(selectedId: number) {
        if (!Utils.isNullOrUndefined(this._paytableBox)) {
            let symbols = this._paytableBox.getChildElementByName("Symbols") as ContainerElement;
            if (!Utils.isNullOrUndefined(symbols)) {
                for (let i = 0; i < symbols.children.length; i++) {
                    let symbol = symbols.children[i] as ImageElement;
                    symbol.visible = false;
                }

                let symbol = symbols.children[selectedId] as ImageElement;
                if (!Utils.isNullOrUndefined(symbol)) {
                    symbol.visible = true;
                }
            }
        }
    }

    /**
     * Highlight selected multiplier by ID.
     * @param selectedId
     * @param loop
     * Tween="alpha" TweenValues0="0;1;1;0;0" TweenDuration0="2;13;2;13" TweenLoop0="true"
     */
    public chooseMultiplier(selectedId: number, loop = true) {
        this._paytableBoxDrawTimer.stop();

        if (!Utils.isNullOrUndefined(this._paytableBox)) {
            let multipliersGlow = this._paytableBox.getChildElementByName("MultipliersGlow") as ContainerElement;
            if (!Utils.isNullOrUndefined(multipliersGlow)) {
                let multiplierGlow = multipliersGlow.children[selectedId] as ImageElement;
                if (!Utils.isNullOrUndefined(multiplierGlow)) {
                    if (loop) {
                        Tweens.removeTweens(multiplierGlow, "all");
                        Tweens.customTween(multiplierGlow, {
                            tween: "alpha",
                            tweenValues: [0, 1, 1, 0, 0],
                            tweenDuration: [2, 13, 2, 13],
                            tweenLoop: loop,
                        });
                    } else {
                        multiplierGlow.alpha = 1;
                    }
                }
            }
        }
    }

    /**
     * Hide all multipliers except selected multiplier by ID.
     * @param selectedId
     * @param loop
     */
    public showOneMultiplier(selectedId: number) {
        if (!Utils.isNullOrUndefined(this._paytableBox)) {
            let multipliers = this._paytableBox.getChildElementByName("Multipliers") as ContainerElement;
            if (!Utils.isNullOrUndefined(multipliers)) {
                for (let i = 0; i < multipliers.children.length; i++) {
                    let multiplier = multipliers.children[i] as ImageElement;
                    multiplier.visible = false;
                }

                let multiplier = multipliers.children[selectedId] as ImageElement;
                if (!Utils.isNullOrUndefined(multiplier)) {
                    multiplier.visible = true;
                }
            }
        }
    }

    /**
     *
     * @param args
     */
    public select(args: any[]) {
        this.paytableBoxSelectedId = args[0];
    }

    /**
     *
     * @param drawSymbolId
     * @param drawDuration
     */
    public stopDrawAfterTime(drawSymbolId: number, drawDuration: number) {
        //this._paytableBoxSelectTimer.on(FrameTimerEvents.Complete, this.paytableBoxSelect.bind(this, [Math.floor(Math.random() * 10)]));
        this._paytableBoxSelectTimer.once(FrameTimerEvents.Complete, this.select.bind(this, [drawSymbolId]));
        this._paytableBoxSelectTimer.start(drawDuration);

        this.duration = drawDuration;
        this._drawStartedTime = Date.now();
    }

    public idle() {
        this._paytableBoxDrawTimer.stop();

        if (!Utils.isNullOrUndefined(this._paytableBox)) {
            let glow_group: ContainerElement;
            let symbols_group: any;
            let multiplierGlow_group: any;

            let symbolsGlow = this._paytableBox.getChildElementByName("SymbolsGlow") as ContainerElement;
            let symbols = this._paytableBox.getChildElementByName("Symbols") as ContainerElement;
            let multipliersGlow = this._paytableBox.getChildElementByName("MultipliersGlow") as ContainerElement;

            for (let i = 0; i < symbols.children.length; i++) {
                if (!Utils.isNullOrUndefined(symbols)) {
                    symbols_group = symbols.children[i] as ImageElement;
                }
                if (!Utils.isNullOrUndefined(symbolsGlow)) {
                    glow_group = symbolsGlow.children[i] as ContainerElement;
                }
                if (!Utils.isNullOrUndefined(multipliersGlow)) {
                    multiplierGlow_group = multipliersGlow.children[i] as ImageElement;
                    multiplierGlow_group.alpha = 0;
                }

                if (this._idleCnt ? i % 2 : !(i % 2)) {
                    if (!Utils.isNullOrUndefined(glow_group)) {
                        Tweens.removeTweens(glow_group, "all");
                        Tweens.customTween(glow_group, {
                            tween: "alpha",
                            tweenValues: [0.9, 0.8, 0],
                            tweenDuration: [30],
                        });
                    }

                    if (!Utils.isNullOrUndefined(multiplierGlow_group)) {
                        Tweens.removeTweens(multiplierGlow_group, "all");
                        Tweens.customTween(multiplierGlow_group, {
                            tween: "alpha",
                            tweenValues: [0.9, 0.8, 0],
                            tweenDuration: [30],
                        });
                    }
                }
            }

            //this.paytableBoxDrawId++;
            //if (this.paytableBoxDrawId >= (symbols.children.length)) {
            //this.paytableBoxDrawId = 0;
            //}

            //this.paytableBoxDrawRoundsCount++;
            //this._paytableBoxDrawTimer.start(this.paytableBoxDrawRoundsCount / 3);

            this._idleCnt = this._idleCnt ? 0 : 1;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/PaytableBoxElement.ts
 **/